import {Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import Icon from 'presentation/icons';
import React from 'react';
import {translations} from 'presentation/translations-new';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {StyledButton} from './styles';
import {FailureAlertProps} from './types';

const {failToloadButtonText, failToloadDescription, failToloadTitle} =
	translations['pt-br'].privateFlow.refund;

export const FailureAlert = ({refetch}: FailureAlertProps) => (
	<Stack
		alignItems="center"
		justifyContent="center"
		spacing={2}
		data-tag-id={RefundTaggingEnum.ERRO_AO_CARREGAR_PAGINA_REEMBOLSO}>
		<IconIllustration size="big" variant="info" customIconName="info-filled" />

		<Typography color="text.primary" variant="h6" textAlign="center">
			{failToloadTitle}
		</Typography>
		<Typography color="text.primary" variant="body1" textAlign="center">
			{failToloadDescription}
		</Typography>

		<StyledButton variant="outlined" endIcon={<Icon name="reload" />} onClick={refetch}>
			{failToloadButtonText}
		</StyledButton>
	</Stack>
);
